function isHttps() {
  const protocolStr = document.location.protocol
  return protocolStr === 'https:'
}

export default {
  getItem(sKey) {
    if (!sKey) {
      return null
    }
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            `(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(
              /[-.+*]/g,
              '\\$&',
            )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
          ),
          '$1',
        ),
      ) || null
    )
  },
  /**
   * 设置 cookie
   * @param {string} sKey cookie 键
   * @param {string} sValue cookie 值
   * @param {number} expiresDay 过期时间，单位天，默认0，表示不过期
   * @returns {boolean} 是否设置成功
   */
  setItem(sKey, sValue, expiresDay = 0) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }

    let cookieStr = `${encodeURIComponent(sKey)}=${encodeURIComponent(sValue)}; path=/`

    // 处理过期时间
    if (expiresDay > 0) {
      const expires = new Date()
      expires.setDate(expires.getDate() + expiresDay)
      cookieStr += `; expires=${expires.toUTCString()}`
    }

    // HTTPS 环境添加 secure 属性
    if (isHttps()) {
      cookieStr += '; sameSite=None; secure'
    }

    document.cookie = cookieStr
    return true
  },
  removeItem(sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false
    }
    document.cookie = `${encodeURIComponent(sKey)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
      sDomain ? `; domain=${sDomain}` : ''
    }${sPath ? `; path=${sPath}` : ''}`
    return true
  },
  hasItem(sKey) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }
    return new RegExp(
      `(?:^|;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=`,
    ).test(document.cookie)
  },
  keys() {
    const aKeys = document.cookie
      // eslint-disable-next-line no-useless-backreference
      .replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '')
      .split(/\s*(?:=[^;]*)?;\s*/)
    for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx])
    }
    return aKeys
  },
}
